import { RESET_DOWNLOAD_TYPE_TO_REGULAR } from "./types";

export const resetDownloadTypeToRegular = () => dispatch => {
	dispatch({ type: RESET_DOWNLOAD_TYPE_TO_REGULAR, payload: "REGULAR" });
};
